import {
  createStyles,
  Grid,
  Theme,
  withStyles,
  type WithStyles,
} from "@material-ui/core";
import { Trans, useTranslations } from "adapters/i18n";
import React from "react";
import { FeedBackPage, Show, TextLabel } from "../../../../shared/components";

type UsersListEmptyProps = { isFilterEmpty: boolean } & WithStyles<
  typeof styles
>;

function UsersListEmpty({ isFilterEmpty, classes }: UsersListEmptyProps) {
  const { t } = useTranslations();

  return (
    <Grid
      container
      direction="column"
      justify="center"
      className={classes.root}
    >
      <FeedBackPage>
        <Grid
          container
          direction="column"
          alignItems="center"
          data-testid="empty-user-list-container"
        >
          <img src="../images/busca.png" alt={t("common:magnifying-glass")} />
          <TextLabel
            block
            color="default2"
            customStyle={{ maxWidth: 400, paddingTop: 10, textAlign: "center" }}
            typographyProps={{ "data-testid": "empty-user-list-label" }}
          >
            <Show
              when={isFilterEmpty}
              fallback={t("common:empty-search-results")}
            >
              <Trans
                i18nKey="user:empty-users-list-message"
                components={{ accent: <span className={classes.textAccent} /> }}
              />
            </Show>
          </TextLabel>
        </Grid>
      </FeedBackPage>
    </Grid>
  );
}

const styles = (theme: Theme) =>
  createStyles({
    root: {
      minHeight: "60vh",
    },
    textAccent: {
      color: theme.palette.primary.main,
      fontWeight: "bold",
      textTransform: "uppercase",
    },
  });

export default withStyles(styles)(UsersListEmpty);
